import React from 'react'
import { ThemeProvider } from 'styled-components'
import { myTheme } from './src/MyTheme.ts'
import './src/fonts/fonts.css'

export const wrapRootElement = ({ element }) => (
    <ThemeProvider theme={myTheme}>{element}</ThemeProvider>
)
